import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Stack } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { useGetBoardElementsByBoardId } from '../../../../../../hooks/services/sKPI/useOfBoard';

const DataserieCloseChecks = (props) => {
    const { 
        inputParam_DataSerieList = null,
        inputParam_DataSerieSelectedList = null,
        inputParam_OnCheckboxChange = null,
    } = props;

    return (
        <Stack tokens={{ childrenGap: 10 }}>
            {
                inputParam_DataSerieList.map((dataserie, index) => 
                    <Checkbox
                        key={index}
                        label={<div>
                                    <div className='ps-1'>
                                        <b>{dataserie.variableName}</b>
                                    </div>
                                    <div className='ps-1' style={{fontSize: "smaller"}}><b> ({dataserie.um})</b></div>
                                </div>}
                        checked={inputParam_DataSerieList.length === 1 ? true : (inputParam_DataSerieSelectedList.find(x => x.dataserieId === dataserie.dataserieId) !== undefined)}
                        disabled={inputParam_DataSerieList.length === 1}
                        onChange={(event, checked) => inputParam_OnCheckboxChange(event, checked, dataserie)}
                    />
                )
            }
        </Stack>
    );
};

DataserieCloseChecks.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_DataSerieList: PropTypes.array.isRequired,
    inputParam_OnCheckboxChange: PropTypes.func.isRequired,
};

export default DataserieCloseChecks;

